import EReviewExpNameOptions from 'enums/EReviewExpOptions';
import { useMemo } from 'react';

export const useGetSelectValues = (expNameFormatString: string) => {
  const allOptions = [
    EReviewExpNameOptions.SCREENNAME,
    EReviewExpNameOptions.DATE,
    EReviewExpNameOptions.TEMPERATURE,
  ];
  return useMemo(() => {
    // extract values inside <>
    const rawValues =
      expNameFormatString?.match(/<([^>]+)>/g)?.map((v) => v.slice(1, -1)) || [];

    const firstValue =
      getReviewExpEnumVal(rawValues[0]) || EReviewExpNameOptions.SCREENNAME;
    const secondValue =
      getReviewExpEnumVal(rawValues[1]) ||
      allOptions.find((v) => v != firstValue) ||
      EReviewExpNameOptions.DATE;
    const thirdValue =
      getReviewExpEnumVal(rawValues[2]) ||
      allOptions.find((v) => v != firstValue && v != secondValue) ||
      EReviewExpNameOptions.TEMPERATURE;

    return { firstValue, secondValue, thirdValue };
  }, [expNameFormatString]);
};

const getReviewExpEnumVal = (reviewVal) => {
  switch (reviewVal) {
    case 'ScreenName':
      return EReviewExpNameOptions.SCREENNAME;
    case 'Date':
      return EReviewExpNameOptions.DATE;
    case 'Temperature':
      return EReviewExpNameOptions.TEMPERATURE;
    default:
      return false;
  }
};
